import Vue from 'vue'
import Vuex from 'vuex'
import User from '@/models/User'
import Project from '@/models/Project'

Vue.use(Vuex)

const UserStatus =
{
	EmailVerified: (1 << 0),
	GlobalAdmin: (1 << 7)
	// Other statuses
};

function updateGAUserData(uid : any)
{
    const ga = (Vue as any).$ga;
    if (ga)
    {
        ga.set('userId', uid);
    }
    else
    {
        console.error('ga failed to init')
    }
}

const store = new Vuex.Store(
{
    modules: {},
    state:
    {
        userdata: <User> <unknown> null,
        projects: new Map<string, Project>(),
        projectsTracker: 0,
        isLTI: false,
        ltiTargetProjectID: ''
    },
    getters:
    {
        user: (state) =>
        {
            return state.userdata;
        },
        projects: (state) =>
        {
            return state.projectsTracker > 0 ? state.projects : state.projects; // reactivity
        },
        lti: (state) =>
        {
            return state.isLTI;
        },
        ltiTargetProjectId: (state) =>
        {
            return state.ltiTargetProjectID;
        }
    },
    mutations: 
    {
        setIsLTI(state, data: boolean)
        {
            state.isLTI = data;
        },
        setTargetLTIProjectId(state, data: string)
        {
            state.ltiTargetProjectID = data;
        },
        setUserData(store, data: any | null | undefined)
        {
            if (data != undefined && data != null)
            {
                data.isVerified = (data.status & UserStatus.EmailVerified) != 0;
                data.isAdmin = (data.status & UserStatus.GlobalAdmin) != 0;
                data.eduEligibilityOverride = data.edu_eligibility_override;
                
                const uid = data.userid;
                updateGAUserData(uid);
            }
            else
            {
                updateGAUserData(null);
            }
            const ud = Object.assign(new User, data);
            if (ud.trialExpiration != null)
            {
                ud.trialExpiration = new Date(ud.trialExpiration.toString() + '+0000');
            }
            Vue.set(store, 'userdata', ud);
        },
        setProjectInList(store, data: { p: Project })
        {
            store.projects.set(data.p.id, data.p); // inserts or updates
            Vue.set(store, 'projectsTracker', (store.projectsTracker + 1) % 1000000);
        },
        clearProjects(store)
        {
            store.projects.clear();
            Vue.set(store, 'projectsTracker', (store.projectsTracker + 1) % 1000000);
        }
    },
    actions:
    {
        // async loadProjectData(store: object)
        // {
        //     // TODO: not sure if the fetch logic should be moved out of Projects.vue and into here
        // }
    }
})

import ProjectModule from './modules/project'

/*
// TODO: This is a hack.  We should later replace usages of gets/mutations with proper class-style usage.
// See here https://github.com/gertqin/vuex-class-modules/
setTimeout(() => {
    console.log('Getters');
    for(let k of Object.keys(store.getters))
    {
        if (k.startsWith('project/'))
        {
            let subbed = k.substr('project/'.length);
            if (subbed.endsWith('Getter'))
            {
                subbed = subbed.substr(0, subbed.length - 'Getter'.length);
            }
            
            Vue.set(store.getters, subbed, store.getters[k]);
        }
    }

    console.log('Mutations');
    for(let k of Object.keys((store as any)._mutations))
    {
        if (k.startsWith('project/'))
        {
            let subbed = k.substr('project/'.length);
            Vue.set((store as any)._mutations, subbed, (store as any)._mutations[k]);
        }
    }
}, 0);*/

import projects from './modules/project'
store.registerModule('project', projects)

export default store
